import {
  captureStack1fzi4aczwc4hg as captureStack,
  toString1pkumu07cwy4m as toString,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var UnknownFieldExceptionClass;
function UnknownFieldException() {
  if (UnknownFieldExceptionClass === VOID) {
    class $ extends SerializationException() {
      constructor(message) {
        return new.target.r1o(message);
      }
      static r1o(message) {
        var $this = this.w1o(message);
        captureStack($this, $this.q1o_1);
        return $this;
      }
      static x1o(index) {
        return this.r1o('An unknown field for index ' + index);
      }
    }
    initMetadataForClass($, 'UnknownFieldException');
    UnknownFieldExceptionClass = $;
  }
  return UnknownFieldExceptionClass;
}
function init_kotlinx_serialization_SerializationException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.v1o_1);
}
var SerializationExceptionClass;
function SerializationException() {
  if (SerializationExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static y1o() {
        var $this = this.ud();
        init_kotlinx_serialization_SerializationException($this);
        return $this;
      }
      static w1o(message) {
        var $this = this.o2(message);
        init_kotlinx_serialization_SerializationException($this);
        return $this;
      }
      static z1o(message, cause) {
        var $this = this.vd(message, cause);
        init_kotlinx_serialization_SerializationException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'SerializationException', $.y1o);
    SerializationExceptionClass = $;
  }
  return SerializationExceptionClass;
}
var MissingFieldExceptionClass;
function MissingFieldException() {
  if (MissingFieldExceptionClass === VOID) {
    class $ extends SerializationException() {
      constructor(message, cause, missingFields, serialName) {
        return new.target.h1p(message, cause, missingFields, serialName);
      }
      static h1p(message, cause, missingFields, serialName) {
        var $this = this.z1o(message, cause);
        captureStack($this, $this.g1p_1);
        $this.e1p_1 = missingFields;
        $this.f1p_1 = serialName;
        return $this;
      }
      static i1p(missingFields, serialName) {
        var tmp0_message = missingFields.q2() === 1 ? "Field '" + missingFields.r2(0) + "' is required for type with serial name '" + serialName + "', but it was missing" : 'Fields ' + toString(missingFields) + " are required for type with serial name '" + serialName + "', but they were missing";
        return this.h1p(tmp0_message, null, missingFields, serialName);
      }
      static j1p(missingField, serialName) {
        var tmp0_missingFields = listOf(missingField);
        var tmp1_message = "Field '" + missingField + "' is required for type with serial name '" + serialName + "', but it was missing";
        return this.h1p(tmp1_message, null, tmp0_missingFields, serialName);
      }
      k1p(newMessage) {
        return MissingFieldException().h1p(newMessage, this, this.e1p_1, this.f1p_1);
      }
    }
    initMetadataForClass($, 'MissingFieldException');
    MissingFieldExceptionClass = $;
  }
  return MissingFieldExceptionClass;
}
//region block: exports
export {
  MissingFieldException as MissingFieldException24tqif29emcmi,
  SerializationException as SerializationExceptioneqrdve3ts2n9,
  UnknownFieldException as UnknownFieldExceptiona60e3a6v1xqo,
};
//endregion

//# sourceMappingURL=SerializationExceptions.mjs.map
